/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $VacationRequest = {
    properties: {
        id: {
    type: 'number',
    isRequired: true,
},
        employeeId: {
    type: 'number',
    isRequired: true,
},
        date: {
    type: 'string',
    format: 'date',
},
        startDate: {
    type: 'string',
    format: 'date',
},
        endDate: {
    type: 'string',
    format: 'date',
},
        reason: {
    type: 'string',
},
    },
};